import { render, staticRenderFns } from "./service-external.vue?vue&type=template&id=0fdc49cc&scoped=true"
import script from "./service-external.vue?vue&type=script&lang=js"
export * from "./service-external.vue?vue&type=script&lang=js"
import style0 from "./service-external.vue?vue&type=style&index=0&id=0fdc49cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc49cc",
  null
  
)

export default component.exports